import type { FaireProductEntity } from "../../entity_types/product";

export const p_jpc5bmrrdc: FaireProductEntity = {
  token: "p_jpc5bmrrdc",
  type: "product",
  name: "Moai Lime Tiki Mug",
  brandName: "Shaker & Makers",
  imageUrl:
    "https://cdn.faire.com/fastly/678c8781f233d90b3bb969df4e9cec2515c97ae3cee35ebac0012c8016c225f0.jpeg",
  priceDollars: 13.55,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fc8266ecc74cd4990fd2121b30b65f86be9b6ce558b32ea1a9289bf284cae58e.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
